import { useEffect, useState } from 'react';
import './style.scoped.css';
import Toolbar from 'src/components/Toolbar';
import PolicyCard from 'src/components/PolicyCard';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import policySt, { PolicyStore } from 'src/stores/PolicyStore';
import { observer } from 'mobx-react-lite';
import { goBackCustom } from 'src/utils';
const CARD_DETAILS = ['payFrequency', 'periodicPremium', 'agentName', 'agentPhone', 'agentCode'];

interface ListPolicyObserverProps {
  policyStore?: PolicyStore;
}
const ListPolicyObserver = observer(({ policyStore }: ListPolicyObserverProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [list, setList] = useState([]);

  useEffect(() => {
    setList(policyStore?.listPolicy ?? []);
  }, [policyStore]);

  const _handleClose = () => {
    history.push("/");
  };

  const _handleBack = () => {
    goBackCustom(history);
  };

  return (
    <div className="screen-container bg-background ct-view fix-scroll">
      <Toolbar
        title={t('periodic_payment')}
        showClose={true}
        onClose={_handleClose}
        onBack={_handleBack}
      />
      <div className="max-w-md mx-auto screenScrollContainer my-policy">

        <div className="bg-surface px-4 pt-4 pb-4 mt-4 border-b border-line">
          <div className="text-base font-bold text-onSurface">
            {`${t('list_policy')} (${list.length})`}
          </div>
        </div>
        <div className="bg-surface px-4 pt-4 pb-4 mb-8">
          <div className="mb-5">
            <div>
              {list.length > 0 ? list.map((policy, index) => 
                <div key={index} className='pb-4'><PolicyCard key={index} policy={policy} buttonType={"payment"} details={CARD_DETAILS} /></div>
              ) : <div className='px-4 pt-4'>{t('no_policy')}</div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

const ListPolicy = () => <ListPolicyObserver policyStore={policySt} />;
export default ListPolicy;
